'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _createClassNames = require('./createClassNames');

var _createClassNames2 = _interopRequireDefault(_createClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = (0, _createClassNames2.default)('ToggleRefinement');

var ToggleRefinement = function ToggleRefinement(_ref) {
  var currentRefinement = _ref.currentRefinement,
      label = _ref.label,
      refine = _ref.refine,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(cx(''), className) },
    _react2.default.createElement(
      'label',
      { className: cx('label') },
      _react2.default.createElement('input', {
        className: cx('checkbox'),
        type: 'checkbox',
        checked: currentRefinement,
        onChange: function onChange(event) {
          return refine(event.target.checked);
        }
      }),
      _react2.default.createElement(
        'span',
        { className: cx('labelText') },
        label
      )
    )
  );
};

ToggleRefinement.propTypes = {
  currentRefinement: _propTypes2.default.bool.isRequired,
  label: _propTypes2.default.string.isRequired,
  refine: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string
};

ToggleRefinement.defaultProps = {
  className: ''
};

exports.default = ToggleRefinement;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/components/ToggleRefinement.js
// module id = 1048
// module chunks = 142807904292071